module.exports = __webpack_public_path__ + "img/Fahmi.419eccef.jpg";